<template>
    <div class="articleWrap11">
        <div>
            <div class="oneUploadWrap oneLine" >
                <span class="label"> <span class="red">*</span> 订货会/活动统一介绍页：</span>
                <el-input type="text" placeholder="请输入介绍页链接(如外部H5页面)" v-model="value" clearable></el-input>
                <el-button type="primary">提交</el-button>
            </div>
            <!-- <el-input-number v-model="uploadPercent" :min="0" :max="100" label="描述文字"></el-input-number> -->
            <div class="oneUploadWrap" v-for="list in 4">
                <div class="title">
                    <span class="red">*</span> 活动报名/登录背景页  
                    
                    
                </div>
                <div class="content">
                    <div class="left">
                        <el-upload class="uploadWrap" :name="'files'" :data="uploadData" :on-progress="uploadProgressHandle" :on-error="uploadErrorHandle"
                            action="https://jsonplaceholder.typicode.com/posts/" :on-success="uploadSuccessHandle" :before-upload="beforeUploadHandle"
                            :show-file-list="false">
                            <div class="uploadInner" slot="trigger" @click="addImgClick('1','list')" v-if="(uploadPercent==0||uploadPercent==100)&&imgArr.length==0">
                                <i class="el-icon-plus uploadIcon"></i>
                            </div>
                            <div class="progressWrap" slot="tip" v-if="uploadPercent>0&&uploadPercent<100">
                                <el-progress type="circle" :stroke-width="7" :percentage="uploadPercent"  :color="customColors"></el-progress>
                            </div>
                        </el-upload>
                        <div class="imgShowBox" v-for="(imgList,imgIndex) in imgArr">
                            <div class="deleteIconBox" @click="deleteImg(imgIndex,imgArr)">
                                <i class="el-icon-delete icon"></i>
                            </div>
                            <img :src="imgList.url" alt="" >
                        </div>
                    </div>
                    <div class="middle">
                        <div class="switchBox">
                            <el-switch v-model="value" active-color="#13ce66" inactive-color="#ddd">
                            </el-switch>
                            <span class="green" v-if="value">优先显示</span>
                            <span class="grey" v-if="!value">优先显示</span>
                        </div>
                        <div class="memo">
                            格式：jpg/jpeg/png格式；尺寸：750*1200；大小：10M以内
                        </div>
                    </div>
                    <div class="right">
                        <img src="../../../assets/images/test/3.jpg" alt=""> 
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                conferenceId:'',
                dialogImageUrl: '',
                dialogVisible: false,
                msg: 'Welcome to Your Vue.js App',
                value:'',
                uploadData:{},
                uploadPercent:0,
                imgArr:[
                ],
                customColors: [
                  {color: '#f56c6c', percentage: 20},
                  {color: '#e6a23c', percentage: 40},
                  {color: '#5cb87a', percentage: 60},
                  {color: '#1989fa', percentage: 80},
                  {color: '#6f7ad3', percentage: 100}
                ]
            }
        },
        methods: {
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
            },
            uploadSuccessHandle(res, file, fileList){
                console.log("图片上传成功回调")
                console.log(res,file,fileList)
                let buffer={
                    id:1,
                    url:'//www.baidu.com/img/bd_logo1.png'
                }
                this.imgArr.push(buffer)
            },
            uploadProgressHandle(event, file, fileList){
                console.log("上传中---")
                console.log(event)
                this.uploadPercent=event.percent.toFixed(2)
            },
            uploadErrorHandle(err, file, fileList){
                console.log("上传失败回调")
                console.log(err)
                alert("失败")
            },
            beforeUploadHandle(file){
                console.log("开始上传之前")
                console.log(file)
                const isMatch = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
                const isLt2M = file.size / 1024 / 1024 < 1
                if (!isMatch) {
                    this.$message.error('图片只能上传.jpg/.jpeg/.png格式')
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 1MB!')
                }
                return isMatch && isLt2M
            },
            addImgClick(type,list){
                console.log(type,list)
            },
            deleteImg(imgIndex,imgArr){
                imgArr.splice(imgIndex,1)
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .articleWrap11 { 
        padding:0 10px; margin-bottom: 70px; background: #f7f7f7;
        .oneUploadWrap{
            padding:10px;background: #fff; margin-top:5px;  
            .title{margin-bottom: 5px;padding-left:5px;}
            .content{
                display: flex; padding-left:10px;
                .left{width: 400px;}
                .middle{flex:1;
                    .switchBox{padding:40px 0;}
                    .memo{color:#999}
                }
                .right{width: 200px;
                    img{max-width: 100%;height: 120px;}
                }
            }
        }
        .oneLine{
            .label{font-weight: bold}
            .input{width: 300px;padding:10px;border-radius: 4px;border:1px solid #ddd;}
            .el-input{width: 300px;}
        }
        .uploadWrap{
            background: #fff;  display: inline-block; background: #fff;
            .uploadInner{ 
                  background: #fff;
                  color:#ccc;  border:1px dotted #bdbdbd; border-radius: 6px; padding:50px;  
                .uploadIcon{font-size: 25px;}
            }
            .uploadInner:hover{color:royalblue;border-color:royalblue;}
        }
        .progressWrap{display: inline-block;}
        .imgShowBox{width: 130px;height: 130px; display: inline-block; vertical-align: top; padding:5px;position: relative; background: #eee;
            img{max-width: 100%;max-height: 100%;}
            .deleteIconBox{position: absolute;top:-10px;right:-10px;padding:5px 8px; border:1px solid red;color:red;border-radius: 20px;background: #fff;}
            .deleteIconBox:hover{background: blueviolet;cursor:pointer;}
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/article.vue